import useEcommerceStore from "@/app/(site)/contexts/ecommerce/store"
import { getDepictLangCode, getDepictMarketCode } from "@/app/(site)/_utils/misc"

const useDepictClientMarketAndLocaleCode = () => {
    const { countryCode, languageCode } = useEcommerceStore(state => ({
        countryCode: state.centraSession.metadata.country.code,
        languageCode: state.centraSession.metadata.language
    }))

    const marketCode = getDepictMarketCode(countryCode)
    const localeCode = getDepictLangCode(languageCode)

    return { marketCode, localeCode }
}

export default useDepictClientMarketAndLocaleCode
